<template>
  <span>
    <span
      v-if="vatPercentage && netPriceInCurrency"
      class="text-base"
    >
      {{ $t('net-price', {netPriceInCurrency, vatPercentage}) }}
    </span>
    <span
      v-if="isNetInvoiceEnabled"
      class="text-base"
    >
      {{ $t('we-provide-net-invoices') }}
    </span>
  </span>
</template>
<script lang="ts">

import type { Money } from 'types/commercetools';
import moneyToNumber from '~~/helpers/commercetools/moneyToNumber';

import { DEFAULT_MONEY_TYPE } from '~~/constants/netPrice';
import type { ProductPrice } from '~~/types/commercetools';
import { PRICE_CUSTOM_FIELDS } from '~~/constants/commerceTools';

export default defineComponent({
  name: 'VatInfo',
  props: {
    isNetInvoiceEnabled: {
      type: Boolean,
      default: false,
    },
    vatPercentage: {
      type: Number,
      default: undefined,
    },
    productPrice: {
      type: Object as PropType<ProductPrice>,
      required: true,
    },
  },

  setup(props) {

    const i18n = useI18n();
    const { currencyCode } = useLocalization();

    const netPrice = computed<Money|null>(() => {

      const rawNetPrice = props.productPrice?.custom?.customFieldsRaw?.find(
        field => field.name === PRICE_CUSTOM_FIELDS.NET_PRICE_CUSTOM_FIELD,
      )?.value;

      if (rawNetPrice) {

        const moneyNetPrice: Money = {
          centAmount: rawNetPrice?.centAmount,
          currencyCode: rawNetPrice?.currencyCode,
          type: rawNetPrice?.type || DEFAULT_MONEY_TYPE,
          fractionDigits: rawNetPrice?.fractionDigits,
        };

        return moneyNetPrice;
      
      }

      return null;
    
    });

    const netPriceInCurrency = computed<string|null>(() => {

      if (netPrice.value) {

        const formattedPrice = moneyToNumber(netPrice.value);

        const priceInCurrency = i18n.n(formattedPrice, {
          style: 'currency',
          currency: currencyCode.value,
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });

        return priceInCurrency;
      
      }

      return null;
    
    });

    return {
      netPriceInCurrency,
    };
  
  },
});


</script>
